module.exports = __webpack_public_path__ + "img/universehand.9b418fcf.png";